export default __webpack_public_path__ + "static/media/code-sandbox-circle.431b8b23.svg";